/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

;(function () {
  // Add custom code below this line
  function callback(mutationList) {
    mutationList.forEach((mutation) => {
      //console.log(mutation.target.classList)
      if (mutation.target.classList.contains("site-header--hovered")) {
        console.log("hovered")
        annoucementElement.style.backgroundColor = "white"
      } else {
        annoucementElement.style.backgroundColor = "transparent"
      }
    })
  }

  const headerElement = document.querySelector("#SiteHeader")
  const annoucementElement = document.querySelector(".announcement-bar-static")

  const observer = new MutationObserver(callback)
  observer.observe(headerElement, {
    attributes: true,
  })

  // .site-header--hovered

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})()
